var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.languageStats)?_c('HorizontalChart',{attrs:{"title":"Languages","data-set":_vm.languageStats}}):_vm._e(),(_vm.countryStats)?_c('MapChart',{staticClass:"mt-12",attrs:{"series":_vm.countryStats}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }